import { useState } from "react";
import {GridRowId} from "@mui/x-data-grid-pro";
export default function useEntityManagerActions() {
    const [selectionModel, setSelectionModel] = useState<GridRowId[]>([]);

    return {
        selectionModel,
        setSelectionModel
    }
}